# Всплывающие окно с новостью
class window.NewsPopup
  constructor: ->
    self = this
    @$popupBlock = $('.popup-overlay') # само всплывающие окно
    @$popupBlockContent = $('.popup-overlay__content') # блок, куда вставляется основной контент новости
    @popupBlockOpenClass = 'popup-overlay--active' # Класс для появления всплывающего окна
    @activeHiddenField
    window.defaultPageTitle = document.title # title по умолчанию
    @shiftHeight = 56
    @prevHref = window.location.pathname + window.location.search
    @prevTitle = document.title
    @windowPosition = 0

    @popupPageOpen = false # флаг который показывает, открыто ли всплывающие окно
    @popupPageAnimate = false # Флаг показывающие, что страница находится в процессе анимации открытия
    @animationFlag = false
    @activeFlag = false
    @activeShiftFlag = false
    @backButtonEventFlag = false

    history.replaceState({popupPage: false, hrefPage: self.prevHref}, self.prevTitle, self.prevHref)

    # закрытие всплывающего окна при клике вне его
    $('.popup-overlay').click (event) ->
      if ($(window).width() >= '1088')
        if self.popupPageOpen
          if $(event.target).closest('.static-page__content-wrapper, .static-page__content-actions, .button-to-top--popup-page').length
            return
          self.closePopup()
          document.title = window.defaultPageTitle

    @initPopupLinks()
    @initToggleBottomHiddenBlocks()
    @initPopupScroll()

    # Для работы кнопки назад в браузере
    window.onpopstate = (event) ->
      event.preventDefault()
      if self.popupPageOpen
        self.backButtonEventFlag = true
        self.closePopup()
      else
        if event.state
          if event.state.popupPage
            self.backButtonEventFlag = true
            self.loadPage(event.state.hrefPage)


    #убираем z-index у элементов списка новостей, чтобы они не появлялись на всплывахах
    $('.popup-block-link').on 'click', ->
      $('.grid-news-list').removeClass('shading-block--content-active')


# инициализируем ссылки, которые открываются во всплывающем окне
  initPopupLinks: ->
    self = this
    $popupOpenLink = $('.popup-block-link') # Ссылка, которая будет открыватся во всплывающем окне

    $popupOpenLink.each(
      ->
        unless $(this).attr("data-event-init") == "true"
          $(this).attr("data-event-init", "true") # вешаем на ссылку атрибут, не позволяющий повторно повешать на неё событие открытия
          # событие клика на ссылку
          $(this).click (e)->
            self.windowPosition = window.pageYOffset
            e.preventDefault()
            popupPageHref = $(this).attr('href')

            unless window.headerObject.sitesListPageOpen
              self.loadPage(popupPageHref)
    )



  loadPage: (popupPageHref)->
    self = this

    #    if window.location.pathname != popupPageHref
    $.ajax
      url: popupPageHref
      type: 'GET'
      dataType: 'html'
      data: {'ajax_load_page': true}
      success: (data) ->
        meta_title = $(data).find('h1').html();
        self.prevHref = window.location.pathname
        self.prevTitle = document.title

        self.$popupBlockContent.html(data)
        document.title = meta_title

        unless self.popupPageOpen
          self.togglePopupPage()
          history.pushState({popupPage: true, hrefPage: popupPageHref}, meta_title, popupPageHref)

        self.initToggleBottomHiddenBlocks()
        window.publication_page = undefined
        new window.Video()
        # взял из togglePopupPage
        self.initPopupCloseButton()
        new window.PageResourcesHelper()

        setTimeout(
          ->
            $('.b-page').addClass('b-page--hidden')
        , 100)
        $('.popup-overlay').scrollTop(0)

        setTimeout(
          ->
            self.initPopupLinks()
        , 1000)




# открытие/закрытие всплывабщего окна
  togglePopupPage: ->
    unless @popupPageAnimate
      @popupPageAnimate = true
      self = this

      if @popupPageOpen
        self.closePopup()
      else
        self.openPopup()


  openPopup: ->
    self = this
    self.windowPosition = $(document).scrollTop()
    if window.headerObject.popupPageOpen
      window.headerObject.siteMapClose()
    if window.searchObject.popupPageOpen
      window.searchObject.closeSearch()


    setTimeout(
      ->
        $('.b-page').css('position', 'relative')
        $('.b-page').css('top', (-self.windowPosition)+'px')
        $('body').addClass('body-overflow')
        $('.b-page').addClass('b-page--hidden')
        $('.gosbar').removeClass('gosbar--scroll-state')
        $('header').removeClass('header--fixed')
        self.headerPositionToggle()
    , 200)
    @$popupBlock.addClass(@popupBlockOpenClass)
    @popupPageOpen = true
    self.endAnimationPopup()



  closePopup: ->
    self = this
    $('body').removeClass('body-overflow')
    $('.b-page').removeClass('b-page--hidden')
    @$popupBlock.removeClass('popup-overlay--fixed-header')
    unless self.backButtonEventFlag
      window.pageInitFlag = false
      history.replaceState({popupPage: false, hrefPage: self.prevHref}, self.prevTitle, self.prevHref)

    self.backButtonEventFlag = false

    setTimeout(
      ->
        self.popupPageOpen = false
        window.headerObject.sitesListPageOpen = false

        self.$popupBlockContent.html('')
        self.headerPositionToggle()

        window.headerObject.editHeaderPosition()
        $('.b-page').css('position', 'relative')
        $('.b-page').css('top', 0)
        $(document).scrollTop(self.windowPosition)
    , 500)

    @$popupBlock.removeClass(@popupBlockOpenClass)
    self.endAnimationPopup()

    window.pageInitCommonFlag = false



  endAnimationPopup: ->
    self = this
    window.shading.shadingDisable(window.shadingContent, 0)
    setTimeout(
      ->
        self.popupPageAnimate = false
        self.$popupBlock.scrollTop(0);
    , 1000)



# из togglePopupPage вынес инициализацию кнопки в отдельный метод
  initPopupCloseButton: ->
    self = this

    $('.js-button-close-block').click (event) ->
      if $(this).attr('href') == undefined
        self.closePopup()
        document.title = window.defaultPageTitle


# Инициализация кнопок внизу новости
  initToggleBottomHiddenBlocks: ->
    self = this;
    $('.static-page__wrapper--links').css('paddingRight', $(window).innerWidth() - $('.popup-overlay__content').innerWidth())

    $('.js-open-hidden-field-button').click ->
      self.toggleBottomHiddenBlock($(this).attr('data-name'))
      self.activeFlag = true


    $('.js-close-hidden-field-button').click ->
      self.toggleBottomHiddenBlock($(this).attr('data-name'))
      self.activeFlag = false


    $('.static-page').click (event) ->
      if (self.activeFlag && !self.animationFlag && $(event.target).closest('.hidden-field').length == 0)
        self.toggleBottomHiddenBlock(self.activeHiddenField);
        self.activeFlag = false

    new window.CopyUrlShare()

  toggleBottomHiddenBlock: (blockId) ->
    self = this
    self.activeHiddenField = blockId
    if (!self.animationFlag)
      $('.static-page__shading-mask').toggleClass('static-page__shading-mask--active')
      self.animationFlag = true
      $('#hf_' + self.activeHiddenField).slideToggle()
      setTimeout(
        ->
          self.animationFlag = false
      , 500)



  initPopupScroll: ->
    self = this
    # переключаем состояния header на всплывающих окнах при скроле
    $('.popup-overlay').scroll ->
      if self.popupPageOpen

        self.headerPositionToggle()


  headerPositionToggle: ->
    self = this
    if $('.popup-overlay').scrollTop() > self.shiftHeight && self.activeShiftFlag == false
      self.initFixedHeader()

    else if self.activeShiftFlag == false
      self.initMainHeader()



  initFixedHeader: ->
    self = this
    self.activeShiftFlag = true

    $('.gosbar').css('top', '-' + $('.popup-overlay').scrollTop() + 'px')
    $('header').css('top', 0)

    $('header').addClass('header--fixed')
    $('.popup-overlay').addClass('popup-overlay--fixed-header')
    $('.static-page').addClass('static-page--shift')
    self.activeShiftFlag = false

  initMainHeader: ->
    self = this
    self.activeShiftFlag = true
    headerScroll = 56

    if self.popupPageOpen
      headerScroll = -$('.popup-overlay').scrollTop() + $('.gosbar').innerHeight()

    $('.gosbar').css('top', '-' + $('.popup-overlay').scrollTop() + 'px')
    $('header').css('top', + headerScroll + 'px')

    $('header').removeClass('header--fixed')
    $('.popup-overlay').removeClass('popup-overlay--fixed-header')
    $('.static-page').removeClass('static-page--shift')
    self.activeShiftFlag = false




// WEBPACK FOOTER //
// ./assets/javascripts/app/news_popup.coffee